const axios = require('axios');
import dispatchEvent from "./dispatchEvent";
import {CART_UPDATED} from "./events";

export default () => {

    axios.get('cart-api').then((response) => {
        if (!response.data.empty) {
            dispatchEvent(CART_UPDATED, response.data);
        }
    });

}
